import { BaseService, IGetList } from '../base/base.service';
import { AppService } from '../main/app.service';
import { BaseEntity } from '../base/base.entity';
import * as angular from 'angular';
import { IBlob } from '.';

export class IApplicant extends BaseEntity {
    name: string;
    email: string;
    phoneNumber: string;
    city: string;
    age: number;
    functionId: string;
    functionName: string;
    date: any;
    preferredTargetAudienceId: string;
    preferredTargetAudienceName: string;
    jobOffer: string;
    iKnowOperandoFrom: string;
    firstStatusDate: any;
    lastStatusDate: any;
    applicationStatusId: string;
    applicationStatusName: string;
    recruiter: string;
    employeeId: string;
    userName: string;
    userId: string;
    zzp: boolean;
    inactive : boolean;
}

export class ApplicantsService extends BaseService<IApplicant> {
    constructor(Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'hr/applicant');
    }

    public postBlob(id, file: any): ng.IPromise<any> {

        // Create FormData to send in the request
        var formData = new FormData();
        formData.append('file', file, file.name);

        return this.Restangular.one('hr/applicant', id)
            .withHttpConfig({ transformRequest: angular.identity })
            .customPOST(formData, 'blobs', undefined, { 'Content-Type': undefined })
            .then((item: Restangular.IElement) => {
                this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
                this.item = item.plain();
                return item.plain();
            })
            .catch((error) => {
                this.AppService.NotifyService.error('Foutmelding', error.data);
                return error;
            });
    }

    public getBlobs(id): ng.IPromise<IGetList<IBlob>> {
        return this.Restangular.one('hr/applicant', id).all('blobs').customGET('').then((collection: Restangular.ICollection) => {
            return collection.plain();
        })
    }

    public deleteBlob(id, blobid): ng.IPromise<any> {
        return this.Restangular.one('hr/applicant', id).customDELETE('/blobs/'+ blobid).then((res) => {
            return res;
        })
    }

    public getBlob(id, blobid):any {


        // this.Restangular.setFullResponse(true);
        // return this.Restangular.one('hr/applicant', id).one('blobs', blobid).customGET('', {}, { responseType: 'blob'}).then((response) => {
        //     console.log(response);
        //     const link = document.createElement('a');
        //     link.href = URL.createObjectURL(response);
        //     link.download = 'test.doc';
        //     link.click();
        //     return new Blob(response.data, { type: response.headers('Content-Type') });
        // })
    }

    public getArchive = (queryParams = null) => {
        return this.Restangular.all(this.itemName).customGET('archive').then((list: Restangular.ICollection) => {
            this.list = list.plain().value;
            return this.listLoaded(this.list);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/applicants.service.ts